<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 09:54:49
 * @LastEditors: xgx
 * @LastEditTime: 2023-07-05 17:10:08
-->
<template>
  <div>
    <div class="top">
      <el-button  v-if="codeData.indexOf('126') != -1" @click="addAdminFn" type="primary"
        >添加角色</el-button
      >
      <div class="search">
        <div class="select-org">
            <TreeSelect v-if="listData.length > 0"  @selectpart="selectpart" :resData="listData"></TreeSelect>
        </div>
        <a-input
          style="width: 170px; margin-right: 20px"
          v-model:value="searchObject.name"
          placeholder="角色名称"
        />
        <el-button @click="search" type="primary">查询</el-button>
      </div>
    </div>
    <coententTable
      :y="height"
      @onShowSizeChange="onShowSizeChange"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="pagination"
      @handleSizeChange="handleSizeChange"
      :loading="loading"
    >
      <template v-slot:operation="scopeVal">
          <div style="display:flex">
              <div
              v-if="codeData.indexOf('127') != -1"
              @click="permissionManagement(scopeVal.scope)"
              style="margin-right: 14px;width:66px"
              class="btnTwo"
              >权限管理</div
            >
            <div
            v-if="codeData.indexOf('128') != -1"
              @click="editAdmin(scopeVal.scope)"
              style="margin-right: 14px;width:66px"
              class="btnTwo"
              >编辑</div
            >
            <div
            v-if="codeData.indexOf('129') != -1"
              @click="open(scopeVal.scope)"
              class="btnThree"
              >删除</div
            >
          </div>
      </template>
    </coententTable>
    <addRole @closeTwo="closeTwo" :listData="listData" :item="item" @close="close" :visible="visible"></addRole>
    <el-dialog
      title="确认删除角色?"
      :visible.sync="dialogVisibleTwo"
      width="450px"
      :before-close="handleClose"
      custom-class="tips-box"
      top="17%"
    >
      <span
        >角色删除是不可以逆的操作，删除后，与该角色关联的管理员账号将失去管理权限</span
      >
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTwo = false">取消</el-button>
        <el-button :loading="deleteBtn" type="danger" @click="deleteOne"
          >确认删除</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {list,organTree, deleteFn} from './role_management';
import addRole from "./add_role.vue";
import TreeSelect from "@/components/tree_selection.vue";
export default {
  data() {
    return {
      height: 0,
      visible: false,
      dialogVisibleTwo:false,
      selectName: "管理员姓名",
      selectValue: "",
      deleteBtn:false,
      organization: undefined,
      role: undefined,
      value: "",
      searchObject:{
         organs:'',
         name:'',
      },
      columns: [
        {
          title: "角色名称",
          dataIndex: "roleName",
          ellipsis: true,
          customCell: column => {
                            return {
                            style: {
                                'min-width': "220px",
                                'max-width': "400px",
                            }
                        };
                        },
                        customHeaderCell: column => {
                        return {
                            style: {
                                'min-width': "220px",
                                'max-width': "400px",
                            }
                        };
                        }
        },
        {
          title: "所属组织",
          dataIndex: "organizationName",
          width: 200,
          ellipsis: true,
        },
        {
          title: "创建人",
          dataIndex: "createUser",
          width: 120,
          ellipsis: true,
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          width: 200,
          ellipsis: true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          width: 260,
          fixed: "right",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 15,
        total: 0,
        pageSizeOptions: ["15", "25", "35"],
      },
      dataSource: [],
      item:{},
      listData:[],
      loading:false,
      codeData:[],
    };
  },
  components: {
    coententTable,
    addRole,
    TreeSelect
  },
  mounted() {
    this.getList();
    this.getOrgList();
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    selectpart(item){
        this.searchObject.organs = item.value;
    },
    search(){
        this.pagination.current = 1;
        this.getList();
    },
     getOrgList(){
      organTree().then((res)=>{
          if(res.code == 0){
              this.listData = res.data;
              let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
              if(userInfo.superManagement == 1){
                 this.listData.unshift({
                id:0,
                organizationName:'全局角色'
              })
              }
            this.$nextTick(()=>{
              this.listData = JSON.parse(JSON.stringify(this.listData))
            })
          }
      })
    },
    getList(){
      this.loading = true;
      list({
        current:this.pagination.current,
        size:this.pagination.pageSize,
        organs:this.searchObject.organs,
        name:this.searchObject.name,
      }).then((res)=>{
           this.dataSource = res.data.records;
          this.pagination.current =  res.data.current;
           this.pagination.total =  res.data.total;
           if(this.pagination.total > 0){
            this.height = document.documentElement.clientHeight - 390;
            window.onresize = () => {
                return (() => {
                  this.height = document.documentElement.clientHeight - 390;
                })();
              };
           }
           if(this.dataSource.length == 0 && this.pagination.current != 1){
                this.pagination.current = this.pagination.current - 1;
                this.getList();
           }
           this.loading = false;
      })
    },
    onShowSizeChange(current) {
       this.pagination.current = current;
       this.getList();
    },
    handleSizeChange(pageSize){
      this.pagination.current = 1;
       this.pagination.pageSize = pageSize;
       this.getList();
    },
    addAdminFn() {
      this.visible = true;
      this.item = {};
    },
    close() {
      this.visible = false;
       this.getList();
    },
    closeTwo(){
      this.visible = false;
    },
    editAdmin(item) {
      this.item = JSON.parse(JSON.stringify(item));
      this.visible = true;
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.item = item;
    },
    permissionManagement(item) {
       this.$router.push({
        path: "/index/userManagement/permission_management",
        query: { 
            title: "权限管理",
            islast: true,
            id:item.id,
            name:item.roleName,
          },
      });
    },
    handleClose(){
        this.dialogVisibleTwo = false
    },
    deleteOne(){
      this.deleteBtn = true;
      deleteFn({id:this.item.id}).then((res)=>{
          if(res.code == 0){
            this.dialogVisibleTwo = false;
              this.getList();
          }
          this.deleteBtn = false;
      })
    }
  },
};
</script>

<style lang="less" scoped>
.top {
  width: 100%;
  padding: 24px;
  border-bottom: solid #E4E7ED 1px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 480px;
    /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
  }
   
  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.deletBox {
  background: red !important;
  .el-message-box__message {
    color: #ccc !important;
  }
}
/deep/ .el-dialog {
  font-weight: 600;
}
/deep/ .el-dialog__body {
  color: #909399;
  font-weight: 400;
}
/deep/ .el-dialog__close {
  color: #000;
  font-weight: 600;
  font-size: 20px;
}
/deep/ .el-dialog__body {
  padding-top: 15px;
}
.delete-input {
  margin-top: 24px;
}
/deep/ .el-dialog__footer {
  padding-top: 0px;
}
.select-org{
  margin-right: 24px;
  width: 200px;
  position: relative;
  /deep/ .el-input__inner{
  height: 32px;
   background: #f7f7f7;
  
}
}
/deep/ .icon{
  top:16px !important;
}
.el-button--primary {
  background: #176de6;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>